(function () {
  'use strict';

  var selector = '.wb-hr';
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function applyMetallic(section) {
    var titleEl = section.querySelector('[data-metallic-title]');

    if (!titleEl || titleEl.dataset.metallicReady === 'true') return;

    titleEl.dataset.metallicReady = 'true';

    var walker = document.createTreeWalker(titleEl, NodeFilter.SHOW_TEXT, null, false);
    var textNodes = [];
    var node;

    while ((node = walker.nextNode())) {
      if (node.textContent.replace(/\s+/g, '').length > 0) {
        textNodes.push(node);
      }
    }

    if (!textNodes.length) return;

    var allWords = titleEl.textContent.trim().split(/\s+/).filter(function (word) {
      return word.length > 0;
    });

    if (!allWords.length) return;

    var metallicCount = Math.min(2, allWords.length);
    var lastNode = textNodes[textNodes.length - 1];
    var lastText = lastNode.textContent;
    var trailingSpaceMatch = lastText.match(/\s+$/);
    var leadingSpaceMatch = lastText.match(/^\s+/);
    var trailingSpace = trailingSpaceMatch ? trailingSpaceMatch[0] : '';
    var leadingSpace = leadingSpaceMatch ? leadingSpaceMatch[0] : '';
    var cleanText = lastText.trim();
    var lastWords = cleanText.split(/\s+/).filter(function (word) {
      return word.length > 0;
    });

    if (!lastWords.length) return;

    var takeFromLast = Math.min(metallicCount, lastWords.length);
    var plainPart = lastWords.slice(0, lastWords.length - takeFromLast).join(' ');
    var metallicPart = lastWords.slice(lastWords.length - takeFromLast).join(' ');
    var fragment = document.createDocumentFragment();

    if (leadingSpace) {
      fragment.appendChild(document.createTextNode(leadingSpace));
    }

    if (plainPart) {
      fragment.appendChild(document.createTextNode(plainPart + ' '));
    }

    var span = document.createElement('span');
    span.className = 'wb-hr__title-metallic';
    span.textContent = metallicPart;
    fragment.appendChild(span);

    if (trailingSpace) {
      fragment.appendChild(document.createTextNode(trailingSpace));
    }

    lastNode.parentNode.replaceChild(fragment, lastNode);
  }

  function initVideos(section) {
    var videos = section.querySelectorAll('.wb-hr__video');

    if (!videos.length) return;

    videos.forEach(function (video) {
      if (prefersReduced) {
        video.pause();
        video.removeAttribute('autoplay');
        return;
      }

      video.play().catch(function () {});
    });
  }

  function initSection(section) {
    if (!section || section.dataset.wbHeroReady === 'true') return;

    section.dataset.wbHeroReady = 'true';

    applyMetallic(section);
    initVideos(section);
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll(selector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector(selector);

    if (!section) return;

    section.querySelectorAll('.wb-hr__video').forEach(function (video) {
      video.pause();
    });
  });
})();